import { EnumMultiplicity } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/EnumMultiplicity';
import { EnumRelationshipType } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/EnumRelationshipType';
import { ReferCrossAssociation } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/ReferCrossAssociation';

export class ReferCrossAssociationExtend {
  public static Init(dto: ReferCrossAssociation) {
    dto.relationshipType = EnumRelationshipType.ReferCrossAssociation;
    dto.sourceMultiplicity = EnumMultiplicity.OneMany;
    dto.targetMultiplicity = EnumMultiplicity.OneMany;
    dto.targetIsNavigation = false; // 目标不能导航，只需要设置源对应的属性即可。
  }
}
